'use client';

import React from 'react';
import { motion } from 'framer-motion';

interface RushDeliveryCardProps {
  enabled: boolean;
  fee: number;
  onToggle: (enabled: boolean) => void;
}

export default function RushDeliveryCard({ enabled, fee, onToggle }: RushDeliveryCardProps) {
  return (
    <button
      type="button"
      onClick={() => onToggle(!enabled)}
      className={`w-full text-left rounded-xl p-3.5 border transition-colors duration-200 ${
        enabled
          ? 'border-amber-400/50 bg-amber-400/[0.08]'
          : 'border-white/[0.08] bg-white/[0.02] hover:border-white/20'
      }`}
    >
      <div className="flex items-center gap-3">
        <div
          className={`w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 ${
            enabled ? 'bg-amber-400/20 text-amber-300' : 'bg-white/[0.05] text-gray-400'
          }`}
        >
          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
            <path d="M13 2L3 14h7v8l10-12h-7z" />
          </svg>
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold text-gray-100">Need it faster?</p>
          <p className="text-xs text-gray-500">Upgrade to Rush Delivery · 12h</p>
        </div>
        <div className="text-right flex-shrink-0">
          <span className={`text-sm font-bold ${enabled ? 'text-amber-300' : 'text-gray-300'}`}>
            +${fee.toFixed(2)}
          </span>
          <span
            className={`mt-1 relative block w-9 h-5 rounded-full transition-colors ${
              enabled ? 'bg-amber-400' : 'bg-white/[0.12]'
            }`}
          >
            <motion.span
              animate={{ left: enabled ? 18 : 2 }}
              transition={{ type: 'spring', stiffness: 500, damping: 30 }}
              className="absolute top-0.5 w-4 h-4 rounded-full bg-white shadow"
            />
          </span>
        </div>
      </div>
    </button>
  );
}
